import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { TitleHeader } from "../components/elements/Header";
import authHeader from "../services/auth.header";
import { useAuth } from "../context/auth";
import { useShop } from "../context/ShopContext";
import { navigate } from "@reach/router";
import ProfileHeader from "../components/ProfileHeader";
import { Settings } from "styled-icons/evaicons-solid";
import authHeader from "../services/auth.header";

const BackBtn = styled.button`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: bold;
  font-size: 2vh;
  text-align: center;
  letter-spacing: 0.005em;
  color: #fdfffc;
  background: transparent;
  border: none;
  cursor: pointer;
  margin-left: 20px;
  right: 3.57%;
  margin-top: 20px;
`;
const ProductPrice = styled.h1`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #fffcf2;
  width: 70px;
  margin-top: 10px;
`;
const ProductLabel = styled.h1`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  color: #fffcf2;
  margin-top: 5px;
`;

const Error = styled.h1`
  font-family: Poppins !important;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #fffcf2;
  margin-top: 5px;
  opacity: 0.5;
`;

const HeadImage = styled.img`
  border-radius: 10px;
  width: 100%;
`;
const ProdImage = styled.img`
  border-radius: 10px;
  width: 20vh;
  height: 30vh;
`;

const Container = styled.div`
  padding: 0px;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 25px;
`;

const ProdContainer = styled.div`
  // margin-left: 15px;
  // margin-right: 15px;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 20px;
`;

const FullStar = styled.img`
  width: 15px;
  height: 15px;
`;
const LabelSvg = styled.img`
display: block;
top: 0;
left: 0;
overflow: visible;
width: 163px;
height: 35px;
}
`;

const LoadBtn = styled.button`
  background: #d4d4d4;
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px;
  border: none;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 26px;
  /* or 186% */
  color: #040303;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
`;

export default function ForYou(props) {
  const [products, setProduct] = useState([]);
  const [ratings, setRating] = useState([]);
  const { StartRating, user } = useAuth();
  const { shopifyId } = useShop();
  const [showMore, setShowmore] = useState(false);
  const [meta, setMeta] = useState({});
  const [nextItem, setNextItem] = useState([]);
  const [currency, setCurrency] = useState("");
  const [convertAmount, setConvertAmount] = useState("");

  const BASE_URL = "https://catway.services.ombre.app/v1/";

  useEffect(() => {
    getProducts();
    getSetting();
  }, [currency]);

  const getSetting = () => {
    return axios
      .get(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profile/settings",
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setCurrency(response.data.data.currency);
      })
      .then(() => {
        actualPrice();
      });
  };

  const actualPrice = () => {
    return axios
      .post(
        "https://settings.services.ombre.app/v1/currency/convert",
        {
          from: "MYR",
          to: currency,
          amount: 1,
        },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        console.log("see converter", response);
        const conAmount = response.data.data.convertedAmount;
        setConvertAmount(conAmount);
      });
  };

  const getProducts = () => {
    return axios
      .get(
        BASE_URL +
          "products?type=for-you&gender=female&limit=11" +
          `&shopifyShopid=${shopifyId}` +
          `&userId=${user && user.data ? user.data.id : user.id}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setProduct(response.data.data);
        setMeta(response.data.meta);
      })
      .catch((err) => {
        console.log("error rec");
      });
  };

  const prodDetails = (prod) => {
    StartRating();
    navigate("/suitability-rating", { state: { data: prod } });
  };

  return (
    <>
      <BackBtn>
        <ProfileHeader />
      </BackBtn>
      <TitleHeader>Hand-picked items for you!</TitleHeader>
      <Container>
        {products && products[0] ? (
          <div onClick={() => prodDetails(products[0])}>
            <HeadImage src={products[0].imageSrc} />
            <ProductPrice>
              {currency.toUpperCase()}
              {(products[0].price * convertAmount).toFixed(2)}
            </ProductPrice>
            <ProductLabel>{products[0].title}</ProductLabel>
          </div>
        ) : (
          <>
            <div
              className="d-flex justify-content-center"
              style={{ marginTop: "180px" }}
            >
              <LabelSvg />
            </div>
            <div className="d-flex justify-content-center">
              <Error>Couldn't load product</Error>
            </div>
          </>
        )}
      </Container>

      <ProdContainer>
        <div className="row mr-0 ml-0 d-flex px-3">
          {products.slice(1, 11).map((prod) => (
            <div
              onClick={() => prodDetails(prod)}
              className="col-6"
              style={{ marginTop: "20px" }}
            >
              <ProdImage src={prod.imageSrc} />
              <ProductPrice>
                {currency.toUpperCase()}
                {(prod.price * convertAmount).toFixed(2)}
              </ProductPrice>
              <ProductLabel>{prod.title}</ProductLabel>
            </div>
          ))}
        </div>
      </ProdContainer>
    </>
  );
}
